const c = {
  name: "OneClickGiving",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M29,13c-2.8,0-5,2.2-5,5h-2c0-3.9,3.1-7,7-7V13z"/>
		<path class="st0" d="M20,18c0-5,4-9,9-9V7c-6.1,0-11,4.9-11,11H20z"/>
		<path class="st0" d="M23.1,34.5c-0.9,0.7-1.8,1.2-2.4,1.6c-0.4,0.2-0.7,0.4-0.9,0.5c-0.1,0.1-0.2,0.1-0.2,0.1c0,0,0,0,0,0
			c0,0,0,0,0,0l0,0l0,0c0,0,0,0-0.5-0.9l-0.5,0.9l0,0l0,0l0,0c0,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.3-0.2-0.6-0.3
			c-0.5-0.3-1.2-0.7-2.1-1.3c-1.7-1.2-4-2.9-6.2-5.1C4.9,25.5,0.2,18.8,0,10.5c0-0.2,0-0.4,0-0.5v0C0,4.5,4.5,0,10,0
			c4,0,7.4,2.3,9,5.6C20.6,2.3,24,0,28,0c5.5,0,10,4.5,10,10v0c0,0.1,0,0.3,0,0.5c-0.1,5.4-2.2,10.2-4.8,14l6.8,2.8V40H28.6
			L23.1,34.5z M2,10c0,0.2,0,0.3,0,0.4l0,0l0,0c0.2,7.6,4.4,13.8,8.8,18.1c2.2,2.1,4.3,3.8,6,4.9c0.8,0.6,1.5,1,2,1.3
			c0.1,0.1,0.2,0.1,0.2,0.1c0.2-0.1,0.4-0.2,0.7-0.4c0.5-0.3,1.2-0.8,2-1.4l-1.3-1.3c-1.2-1.2-1.2-3.1,0-4.2
			c0.6-0.6,1.3-0.9,2.1-0.9c0.8,0,1.5,0.3,2.1,0.9l1.4,1.4V18c0-1.7,1.3-3,3-3c0.8,0,1.6,0.3,2.1,0.9c0.6,0.5,0.9,1.3,0.9,2.1v4.7
			c2.3-3.5,3.9-7.6,4-12.2l0,0l0,0c0-0.1,0-0.2,0-0.4c0-4.4-3.6-8-8-8c-4.4,0-8,3.6-8,8h-2c0-4.4-3.6-8-8-8C5.6,2,2,5.6,2,10z
			 M28,18v12.4l-1.7,1.7L23.2,29c-0.2-0.2-0.4-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.7,0.3c-0.4,0.4-0.4,1,0,1.4l7.6,7.6H38v-9.3l-8-3.3V18
			c0-0.3-0.1-0.5-0.3-0.7l0,0l0,0C29.5,17.1,29.3,17,29,17C28.5,17,28,17.5,28,18z"/>
		<path class="st0" d="M18.5,36.9c0,0,0,0,0.5-0.9l0.5,0.9L19,37.1L18.5,36.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as OneClickGiving
};
